export enum PstResultType {
    Installment = 1,
    FutureValue = 2,
}
